<template>
  <div class="sarpa-popup hospital-popup">
    <div class="popup-header" style="background: linear-gradient(135deg, #1565C0 0%, #1976D2 100%);">
      <div class="popup-header-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H8v-2h4V8h2v4h4v2z"/>
        </svg>
      </div>
      <div class="popup-header-text">
        <div class="popup-entity-name">{{ data.name || 'Hospital' }}</div>
        <div class="popup-entity-sub">{{ data.category || 'Medical Facility' }}</div>
      </div>
    </div>

    <div class="popup-body">
      <div class="popup-row" v-if="data.Districtname">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
        <span>{{ data.Districtname }}</span>
      </div>
      <div class="popup-row" v-if="data.address">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>
        <span class="popup-address">{{ data.address }}</span>
      </div>
      <div class="popup-badges" v-if="data.category">
        <span class="popup-badge badge-blue">
          {{ data.category }}
        </span>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'HospitalPopup',
  props: {
    data: { type: Object, required: true },
  },
  methods: {
    navigate() {
      if (this.data.location && this.data.location.length === 2) {
        const lat = this.data.location[1];
        const lng = this.data.location[0];
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`, '_blank');
      }
    },
    viewDetails() {
      if (this.$router && this.data._id) {
        this.$router.push({ name: 'viewHospital', query: { id: this.data._id } });
      }
    },
  },
};
</script>

<style>
/* Shared base styles in UserPopup.vue — only add hospital-specific overrides here */
.hospital-popup .popup-address {
  font-size: 11.5px;
  color: #6b7280;
  line-height: 1.4;
}
.popup-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 4px;
}
.popup-badge {
  font-size: 10.5px;
  font-family: poppinsmedium, sans-serif;
  padding: 3px 8px;
  border-radius: 20px;
}
.badge-green { background: #dcfce7; color: #166534; }
.badge-blue  { background: #dbeafe; color: #1e40af; }
.badge-gray  { background: #f3f4f6; color: #6b7280; }
.hospital-popup .popup-btn.primary {
  background: linear-gradient(135deg, #1565C0 0%, #1976D2 100%);
}
</style>
